import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router';

import authMiddleware from '@/router/middlewares/auth';
import {
  developmentRoutes,
  privateRoutes,
  publicRoutes,
} from '@/router/routes/index';

const routes: Array<RouteRecordRaw> = [...publicRoutes, ...privateRoutes];

if (import.meta.env.MODE === 'dev') routes.push(...developmentRoutes);

const router = createRouter({
  routes,
  history: createWebHistory(),
  scrollBehavior() {
    return { top: 0 };
  },
});

authMiddleware(router);

export default router;
